import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import './assessmentSkeleton.css';

const AssessmentSkeleton = () => {
  return (
    <div className="p-4">
      {/* Header */}
      {/* <div className="skeleton mb-4" style={{ height: '20px', width: '200px' }}></div> */}

      {/* Score Box */}
      <Card className="mb-4 w-50">
        <CardBody>
          <div className="skeleton mb-3" style={{ height: '60px', width: '120px' }}></div>
          <Row>
            <Col><div className="skeleton" style={{ height: '14px', width: '60px' }}></div></Col>
            <Col><div className="skeleton" style={{ height: '14px', width: '60px' }}></div></Col>
            <Col><div className="skeleton" style={{ height: '14px', width: '60px' }}></div></Col>
          </Row>
          <Row className='mt-3'>
            <Col><div className="skeleton" style={{ height: '14px', width: '30px' }}></div></Col>
            <Col><div className="skeleton" style={{ height: '14px', width: '30px' }}></div></Col>
            <Col><div className="skeleton" style={{ height: '14px', width: '30px' }}></div></Col>
          </Row>
        </CardBody>
      </Card>

      {/* Tabs */}
      <Row className="mb-4">
        <Col xs="auto"><div className="skeleton" style={{ height: '20px', width: '80px' }}></div></Col>
        <Col xs="auto"><div className="skeleton" style={{ height: '20px', width: '80px' }}></div></Col>
        <Col xs="auto"><div className="skeleton" style={{ height: '20px', width: '80px' }}></div></Col>
      </Row>

      {/* Questions */}
      {[...Array(4)].map((_, idx) => (
        <Card className="mb-3" key={idx}>
          <CardBody>
            <div className="skeleton mb-2" style={{ height: '18px', width: '70%' }}></div>
            <div className="skeleton mb-2" style={{ height: '14px', width: '40%' }}></div>
            <div className="skeleton" style={{ height: '16px', width: '100px' }}></div>
          </CardBody>
        </Card>
      ))}
    </div>
  );
};

export default AssessmentSkeleton;
